import { SidebarMenu } from '../../../enum/SidebarMenu';
import icon from '../../../assets/img/svg/sidebar/health-monitor.svg';

export const healthMonitor = {
  sidebarMenuType: SidebarMenu.HEALTH_MONITOR,
  label: 'sidebar.healthMonitor.title',
  path: '/health-monitor',
  routes: undefined,
  icon: icon,
  footerConfig: { pagging: true, grid: true, rowsPerPage: true },
};
